export default __webpack_public_path__ + "static/media/vvrs.9640d289.png";